import flatten from 'flat';
import { difference, get, groupBy, has, isFunction, isString, keys, map, values } from 'lodash';
import generateNewTheme from './generateNewTheme';
import { generateTheme } from './generateTheme';

const combineValues = (...functions) => {
  const resultFunc = functions.pop();

  return (props) => {
    if (isFunction(resultFunc)) {
      return resultFunc(...map(functions, (func) => (isFunction(func) ? func(props) : func)));
    }
  };
};

//TODO: fix
const checkThemeSchema = (theme) => {
  const mappingsPaths = values('this got the mappings');
  const themeFlatten = keys(flatten(theme));

  const results = groupBy(mappingsPaths, (path) => (has(theme, path) ? 'FOUND' : 'MISSING'));
  results['REDUNDANT'] = difference(themeFlatten, mappingsPaths);

  return results;
};

const switchProp = (attrNameOrFunction, mappings) => (props) => {
  const val = get(mappings, typeof attrNameOrFunction === 'function' ? attrNameOrFunction(props) : get(props, attrNameOrFunction));
  if (isFunction(val)) {
    return val(props);
  }
  if (isString(val)) {
    return val;
  }
};

export { generateTheme, switchProp, generateNewTheme, checkThemeSchema, combineValues };
